
import type { ExpandType } from "./expand-type.js";
import type { GetNonEmptyKeys, GetPossibleEmptyProps } from "./utils.js";
import type { IfNever } from "./conditional.js";

type _RemoveEmptyProperties<
  T extends object,
  IncludeOptionalProps extends boolean = true,
  TPossibleEmptyKeys extends keyof T = GetPossibleEmptyProps<T, IncludeOptionalProps>,
  TNonEmptyKeys extends keyof T = GetNonEmptyKeys<T, IncludeOptionalProps>
> = ExpandType<
  { [ K in TPossibleEmptyKeys as IfNever<Exclude<T[ K ], null | undefined | "">, { T: never, F: K }> ]?: Exclude<T[ K ], null | undefined | ''> } &
  Pick<T, TNonEmptyKeys>
>;

export type RemoveEmptyProperties<T extends object> = _RemoveEmptyProperties<T>;


export function removeEmptyProperties<T extends object> (obj: T): RemoveEmptyProperties<T> 
{
  return Object.fromEntries(
    Object.entries(obj).filter(([ _key, value ]) => value != null && value !== '')
  ) as RemoveEmptyProperties<T>;
}

export function deleteEmptyProperties<T extends object> (obj: T): RemoveEmptyProperties<T> {
  const allProps = Object.keys(obj);

  for (const prop of allProps) {
    if (obj[ prop ] == null || obj[ prop ] === "") {
      delete obj[ prop ];
    }
  }
  return obj as unknown as RemoveEmptyProperties<T>;
}